import { render, staticRenderFns } from "./MailStatus.vue?vue&type=template&id=2799db6e&"
import script from "./MailStatus.vue?vue&type=script&lang=js&"
export * from "./MailStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports